export enum StepEnum{
    ActiveRoleField = 'active_role_field',
    TemplateEditor = 'template_editor',
    Completed = 'completed',
    BilectaBank = 'bilecta_bank'
}

export enum StepNumberEnum{
    step1 = 'active_role_field',
    step2 = 'template_editor',
    step3 = 'completed',
    step4 = 'bilecta_bank'
}

export enum StepStatusEnum{
    Active = 'active',
    Inactive = 'inactive'
}

export type IStepsTranslation = {
    [key in StepEnum]: {
        heading: string
        subheading: string
    }
}

export const stepsTranslation: IStepsTranslation = {
    [StepEnum.ActiveRoleField]: {
        heading: "Template EForm - step personal Info heading (Template - section) - Personal Info",
        subheading: "Template EForm - step add personal info subheading (Template - section) - Add personal info"
    },
    [StepEnum.TemplateEditor]: {
        heading: "Template EForm - step document heading (Template - section) - Document",
        subheading: "Template EForm - step review document subheading (Template - section) - Review document"
    },

    [StepEnum.Completed]: {
        heading: "Template EForm - step signature heading (Template - section) - Signature",
        subheading: "Template EForm - step process Completed subheading (Template - section) - Process Completed"
    },
    [StepEnum.BilectaBank]: {
        heading: "",
        subheading: ""
    }
}

export function steps(){
    return [
        {
            id: null,
            convert_to_eform_setting_id: null,
            heading : '',
            subheading : '',
            key : StepEnum.ActiveRoleField,
            order : 1,
            status: StepStatusEnum.Active
        },
        {
            id: null,
            convert_to_eform_setting_id: null,
            heading : '',
            subheading : '',
            key : StepEnum.TemplateEditor,
            order : 3,
            status: StepStatusEnum.Active
        },
        {
            id: null,
            convert_to_eform_setting_id: null,
            heading : '',
            subheading : '',
            key : StepEnum.Completed,
            order : 4,
            status: StepStatusEnum.Active
        },
    ]
}